import {
    FETCH_ADMIN_USERS_REQUEST,
    GET_SESSION,
    GET_USERS,
    PUT_USERS,
    SESSION_READY,
    SET_ACCOUNT_INFO,
    SET_CLICKED_USER,
    USERS_ERROR,
} from '../ActionTypes';

const initActions = function (services) {
    const axiosCall = services.axios.Axios();
    const sessionStrg = services.session;
    const auth = services.auth;
    const cookieStrg = services.cookies;

    const fetchAdminUsersRequest = () => {
        return {
            type: FETCH_ADMIN_USERS_REQUEST,
        };
    };

    const getSession = (session) => {
        return {
            type: GET_SESSION,
            payload: session,
        };
    };

    const sessionReady = (status) => {
        return {
            type: SESSION_READY,
            payload: status,
        };
    };

    const fetchSession = (userEmail) => {
        return async (dispatch) => {
            try {
                var response = await axiosCall.post(
                    `auth/login?email=` + userEmail
                );
                const session = response.data.data;
                sessionStorage.setItem(`sessionKey`, JSON.stringify(session));

                dispatch(getSession(session.id));
                dispatch(sessionReady(true));
            } catch (error) {
                const errorMsg = error.message;
                dispatch(usersError(errorMsg));
            }
        };
    };

    const setAccountInfo = () => {
        return {
            type: SET_ACCOUNT_INFO,
            payload: auth.GetAccount(),
        };
    };

    /**
     * @deprecated
     */
    const fetchAdminUsers = () => {
        return async (dispatch) => {
            try {
                var response = await axiosCall.get(`accounts/administrators`);
                const users = response.data;
                dispatch(getUsers(users));
            } catch (error) {
                const errorMsg = error.message;
                dispatch(usersError(errorMsg));
            }
        };
    };

    const getAssignableUsers = () => async () =>
        axiosCall.get('accounts/assignable');

    const fetchAssignableUsers = () => {
        return async (dispatch) => {
            try {
                var response = await axiosCall.get(`accounts/assignable`);
                const users = response.data;
                dispatch(getUsers(users));
            } catch (error) {
                const errorMsg = error.message;
                dispatch(usersError(errorMsg));
            }
        };
    };

    const fetchUser = (id) => {
        return async (dispatch) => {
            try {
                var response = await axiosCall.get(`accounts/` + id);
                const user = response.data;
                dispatch(getUsers(user));
            } catch (error) {
                const errorMsg = error.message;
                dispatch(usersError(errorMsg));
            }
        };
    };

    const getUsers = (users) => {
        return {
            type: GET_USERS,
            payload: users,
        };
    };

    const usersError = (error) => {
        return {
            type: USERS_ERROR,
            payload: error,
        };
    };

    const putUsers = (users) => {
        return {
            type: PUT_USERS,
            payload: users,
        };
    };

    const setClickedUser = (user) => {
        return {
            type: SET_CLICKED_USER,
            payload: user,
        };
    };

    const setRoles = (x, newRoles) => {
        return async (dispatch) => {
            try {
                var response = await axiosCall.patch(`accounts/` + x, {
                    roles: newRoles,
                });
                return response.data.data;
            } catch (error) {
                const errorMsg = error.message;
                dispatch(usersError(errorMsg));
            }
        };
    };

    const saveEditedUserInfo = (
        id,
        editedUserInfo,
        editedActivation,
        editedRoles
    ) => {
        return async (dispatch) => {
            try {
                var response = await axiosCall.patch(`accounts/` + id, {
                    firstName: editedUserInfo.firstName,
                    lastName: editedUserInfo.lastName,
                    email: editedUserInfo.email,
                    title: editedUserInfo.title,
                    activated: editedActivation,
                    roles: [...editedRoles],
                });
                dispatch(fetchUser(id));
                return response.data.data;
            } catch (error) {
                const errorMsg = error.message;
                dispatch(usersError(errorMsg));
            }
        };
    };

    const saveNewUserInfo = (newUserInfo) => {
        return async (dispatch) => {
            try {
                var response = await axiosCall.post(`accounts`, newUserInfo);
                return response.data.data;
            } catch (error) {
                const errorMsg = error.message;
                dispatch(usersError(errorMsg));
            }
        };
    };

    const sessionLogin = (loginFunction, InteractionType, requestObject) => {
        return async (dispatch) => {
            try {
                // clean up old session and cookie storages and then try to login.
                sessionStrg.delete(`sessionKey`);
                sessionStrg.delete(`token`);
                cookieStrg.clearCookies();
                dispatch(getSession(''));
                dispatch(sessionReady(false));
                await loginFunction(InteractionType, requestObject);
            } catch (error) {
                const errorMsg = error.message;
                dispatch(usersError(errorMsg));
            }
        };
    };

    const sessionLogout = () => {
        return async (dispatch) => {
            try {
                sessionStrg.delete(`token`);
                cookieStrg.clearCookies();
                dispatch(getSession(''));
                dispatch(sessionReady(false));
            } catch (error) {
                const errorMsg = error.message;
                dispatch(usersError(errorMsg));
            } finally {
                auth.SignOut();
            }
        };
    };

    const getValidAuth = async () => {
        await services.axios.checkValidAuth();
    };

    return {
        fetchAdminUsers,
        fetchAdminUsersRequest,
        fetchAssignableUsers,
        fetchSession,
        fetchUser,
        getAssignableUsers,
        getSession,
        getUsers,
        getValidAuth,
        putUsers,
        saveEditedUserInfo,
        saveNewUserInfo,
        sessionLogin,
        sessionLogout,
        sessionReady,
        setAccountInfo,
        setClickedUser,
        setRoles,
        usersError,
    };
};

export default initActions;
